
<template>
    <b-row class="mem_text position-relative" v-if="can_show" >
        <div class="edit_text" @click="edit_text">
            <fa :icon="faEdit"/>
        </div>
        
        <b-col sm="2" class="position-relative" v-if="show_label">
            <label>{{label}}</label>
        </b-col>
        <b-col :sm="show_label ? 10 : 12" v-html="text" class="bd-callout bd-callout-info"></b-col>
    </b-row>
</template>

<script>

import Fa from 'vue-fa'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "mem_text",
    components : {
        Fa
    },
    props: {
        text: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        
        show_label : {
            type : Boolean,
            default: true
        },
        
        is_show : {
            type : Boolean,
            default : true
        },
    },
    data() {
        return {
            faEdit
        }
    },
    
    methods : {
        edit_text() {
            this.$emit('edit_text');
        }
    },
    
    computed : {
        can_show () {
            return !!(this.is_show && this.text.length > 0);
        }
    }
    
}
</script>


<style scoped>
.mem_text {
    margin-bottom: 15px;
    width: 101%;
    padding-left: 15px;
}

.edit_text {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    z-index: 10;
}

</style>